<template>
  <footer class="whFooter">
    <div class="whContainer">
      <div class="whFootGrid">
        <div class="whFootBrand">
          <a class="whBrand" href="/">
            <span class="whLogo" aria-hidden="true">
              <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="lg-foot" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stop-color="#5B23FF" />
                    <stop offset="1" stop-color="#008BFF" />
                  </linearGradient>
                </defs>
                <rect x="16" y="16" width="480" height="480" rx="120" fill="url(#lg-foot)" />
                <g transform="rotate(-45 256 256)">
                  <path d="M224,133 L288,133 A32,32 0 0 1 320,165 L320,287 L192,287 L192,165 A32,32 0 0 1 224,133 Z" fill="#FFFFFF" />
                  <path d="M192,292 L320,292 L320,347 A32,32 0 0 1 288,379 L224,379 A32,32 0 0 1 192,347 Z" fill="#FFFFFF" />
                </g>
                <path d="M400,48 Q400,112 464,112 Q400,112 400,176 Q400,112 336,112 Q400,112 400,48 Z" fill="#E4FF30" />
              </svg>
            </span>
            <span class="whBrandText">
              <span class="whBrandName">无痕AI</span>
            </span>
          </a>
          <p class="whFootDesc">专注AI视频消除与画质增强技术，依托自研视觉模型，交付效果领先的视频无痕消除与增强产品。</p>
        </div>

        <div class="whFootCols">
          <div>
            <div class="whFootTitle">产品</div>
            <a href="/video-subtitle-removal-app/">在线去字幕</a>
            <a href="/video-watermark-removal-app/">在线视频去水印</a>
            <a href="/video-object-removal-app/">在线视频消除</a>
            <a href="/video-enhance-app/">在线视频增强</a>
          </div>
          <div>
            <div class="whFootTitle">API</div>
            <a href="/video-subtitle-removal-api/">视频去字幕API</a>
            <a href="/video-watermark-removal-api/">视频去水印API</a>
            <a href="/api-docs/">API 文档</a>
            <a href="https://api.wuhenai.com/manager/">API 管理后台</a>
          </div>
          <div>
            <div class="whFootTitle">工具</div>
            <a href="/doubao-watermark-remover-app/">豆包去水印</a>
            <a href="/jimeng-watermark-remover-app/">即梦去水印</a>
            <a href="/keling-watermark-remover-app/">可灵去水印</a>
            <a href="/douyin-watermark-remover-app/">抖音去水印</a>
            <a href="/bilibili-watermark-remover-app/">B站去水印</a>
            <a href="/rednote-watermark-remover-app/">小红书去水印</a>
          </div>
          <div>
            <div class="whFootTitle">资源</div>
            <a href="/tutorials/">使用教程</a>
            <a href="/privacy/">隐私政策</a>
            <a href="/user-agreement/">用户协议</a>
            <a href="/refund-policy/">退款协议</a>
          </div>
        </div>
      </div>

      <div class="whFootBottom">
        <span>© 2026 无痕AI · 杭州岁羽网络科技有限公司</span>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">浙ICP备2024067080号</a>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.whFooter {
  --color-highlight: #E4FF30;
  --bg-1: #362F4F;
  --line: #4A4270;
  --line-strong: #5C5486;
  --text: #F4F2FB;
  --text-2: #C4BEDD;
  --text-3: #8A82AB;
  --primary-glow: rgba(91, 35, 255, 0.55);
  --radius: 14px;
  --ease-out: cubic-bezier(0.22, 1, 0.36, 1);
  --shadow-float: 0 24px 60px -22px rgba(10, 8, 24, 0.75);
  --font-mono: ui-monospace, "SF Mono", "JetBrains Mono", "Cascadia Mono", Menlo, Consolas, monospace;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "HarmonyOS Sans SC", "Hiragino Sans GB", "Microsoft YaHei", "Segoe UI", sans-serif;
  border-top: 1px solid var(--line);
  padding: 56px 0 40px;
}

.whContainer {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 24px;
}

.whFootGrid {
  display: flex;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
}

.whFootBrand {
  max-width: 320px;
}

.whBrand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  margin-bottom: 16px;
}

.whLogo {
  width: 42px;
  height: 42px;
  flex: none;
  border-radius: 11px;
  box-shadow: 0 4px 18px var(--primary-glow);
  overflow: hidden;
}

.whLogo svg {
  width: 100%;
  height: 100%;
  display: block;
}

.whBrandText {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.whBrandName {
  font-size: 18px;
  font-weight: 800;
  color: var(--text);
  letter-spacing: 0.01em;
}

.whBrandSlogan {
  font-size: 11.5px;
  color: var(--text-3);
  font-weight: 500;
  letter-spacing: 0.02em;
}

.whFootDesc {
  font-size: 14px;
  color: rgba(244, 242, 251, 0.68);
}

.whFootCols {
  display: flex;
  gap: 64px;
}

.whFootCols h4, .whFootCols .whFootTitle {
  font-size: 13px;
  color: rgba(244, 242, 251, 0.72);
  font-family: var(--font-mono);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 16px;
}

.whFootCols a {
  display: block;
  font-size: 14px;
  color: rgba(244, 242, 251, 0.78);
  padding: 5px 0;
  transition: color 0.2s;
  text-decoration: none;
}

.whFootCols a:hover {
  color: var(--color-highlight);
}

.whFootBottom {
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid var(--line);
  display: flex;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  font-size: 12px;
  color: rgba(244, 242, 251, 0.62);
}

.whFootBottom a {
  color: rgba(244, 242, 251, 0.70);
  transition: color 0.2s;
  text-decoration: none;
}

.whFootBottom a:hover {
  color: var(--color-highlight);
}
</style>
